import { message } from "antd";
import { useState } from "react";

const TagInput = ({
  label,
  placeholder,
  name,
  value = [],
  onChange,
  error,
  addOnBlur = false,
  addOnEnter = true,
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleAdd = () => {
    const trimmed = inputValue.trim();

    if (!trimmed) return;

    // Duplicate validation
    if (value.includes(trimmed)) {
      message.error("Already added!");
      return;
    }

    const updated = [...value, trimmed];
    onChange(name, updated);
    setInputValue("");
  };

  const handleRemove = (tag) => {
    const updated = value.filter((item) => item !== tag);
    onChange(name, updated);
  };

  return (
    <>
      <div className="col-md-12">
        <div className="form-group mb-4 ">
          <label class="d-block ct_fs_14 mb-2 ct_darkblue_text">{label}</label>
          <div className="position-relative">
            <input
              class="form-control ct_input "
              style={{ paddingRight: "60px" }}
              placeholder={placeholder}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (!addOnEnter) return;
                if (e.key === "Enter" || e.key === ",") {
                  e.preventDefault();
                  handleAdd();
                }
              }}
              onBlur={() => {
                if (addOnBlur) {
                  handleAdd();
                }
              }}
              type="text"
            />
            <div className="ct_add_skill_plus ct_show_eye" onClick={handleAdd}>
              <i className="fa-solid fa-plus"></i>
            </div>
          </div>
          <ul
            className="d-flex mt-2 align-items-center gap-2 flex-wrap ct_para_scroll ct_custom_scroll"
            style={{ maxHeight: "150px" }}
          >
            {value.map((tag, index) => (
              <li key={index}>
                <span
                  className="ct_shadow_badge text-start d-flex align-items-center justify-content-between gap-1"
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {tag}{" "}
                  <span
                    class="ct_cursor_pointer"
                    onClick={() => handleRemove(tag)}
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                </span>
              </li>
            ))}
          </ul>
          {error && <span style={{ color: "red" }}>{error}</span>}
        </div>
      </div>
    </>
  );
};

export default TagInput;
